/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
import{o as e,t,u as n}from"vendor/lit";import{a as r,i,t as a}from"vendor/decorate";import{icons as o}from"components-icon/Icons";var s=class extends t{constructor(...e){super(...e),this.icon=`vehicle`,this.filled=!1}static{this.styles=n`.container {
  padding: calc(var(--icon-pad) / 2);
  height: var(--icon-size, 2.4rem);
  width: var(--icon-size, 2.4rem);
  justify-content: center;
  align-items: center;
  display: flex;
}

.container[data-filled="true"] {
  background-color: rgb(var(--icon-color, var(--text-color-og) / .1));
  height: var(--icon-size, 3rem);
  width: var(--icon-size, 3rem);
  padding: calc(var(--icon-pad, var(--icon-size, 1.5rem)) / 4);
  border-radius: 50%;
}

@media (min-width: 769px) {
  .container[data-filled="true"] {
    padding: calc(var(--icon-pad, var(--icon-size, 3rem)) / 4);
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0;
  }
}

svg {
  stroke-width: var(--icon-stroke-width);
  height: var(--icon-size, 100%);
  width: var(--icon-size, 100%);
  transition: fill .2s ease-in-out;
}
`}render(){return e`<div class="container" data-filled="${this.filled}">
      ${o[this.icon]}
    </div>`}};a([i({type:String})],s.prototype,`icon`,void 0),a([i({type:Boolean,reflect:!0})],s.prototype,`filled`,void 0),s=a([r(`kanter-icon`)],s);export{s as KanterIcon};